import { useState } from "react";

import { AppIcon } from "../Common/AppIcon";

import '../../styles/Animator.css';
import '../../styles/NavLink.css';

export function NavLink({ link }) {

  const [isHovered, setIsHovered] = useState(false);

  return(
    <a
      className={`has-text-centered m-3 a-navbar ${ isHovered ? 'floating' : ''}`}
      onMouseEnter={()=>{setIsHovered(true)}}
      onMouseLeave={()=>{setIsHovered(false)}}
      >
      <div className="link-container">
        <AppIcon iconName={link.service} /> 
        <small className="pl-1">{link.service}</small>
      </div>
    </a>
  );
}